import { t } from 'i18next';
export function getTextKeyForScoreBucket(score) {
    const wordedScoreBuckets = [
        {
            range: [0.9, 1.0],
            text: t('Excellent'),
        },
        {
            range: [0.7, 0.9],
            text: t('Very good'),
        },
        {
            range: [0.6, 0.7],
            text: t('Good'),
        },
        {
            range: [0, 0.6],
            text: t('out of 10'),
        },
    ];
    const bucketFound = wordedScoreBuckets.find((bucket) => {
        return score > bucket.range[0] && score <= bucket.range[1];
    });
    return bucketFound === null || bucketFound === void 0 ? void 0 : bucketFound.text;
}
export function formatScore(scoreBetweenZeroAndOne) {
    const scoreBetweenZeroAndTen = scoreBetweenZeroAndOne * 10;
    return scoreBetweenZeroAndTen.toPrecision(2).replace('.', ',');
}
//# sourceMappingURL=scoreUtil.js.map